export const NOTIFICATION_SETTINGS_KEYS = {
  VOLUME: 'notificationVolume',
  MUTED: 'notificationMuted',
};

export const THEME_OPTIONS = {
  LIGHT: 'light',
  DARK: 'dark',
  SEPIA: 'sepia',
  FLUX: 'flux',
  SENTIENT: 'sentient',
  NEXUS: 'nexus',
};

export const THEME_VALUES = Object.freeze(Object.values(THEME_OPTIONS));

export const THEME_BODY_CLASSES = Object.freeze(
  THEME_VALUES.filter((theme) => theme !== THEME_OPTIONS.DARK)
);

export const THEME_SELECT_OPTIONS = Object.freeze(
  THEME_VALUES.map((value) => ({
    value,
    label: `${value.charAt(0).toUpperCase()}${value.slice(1)}`,
  }))
);

export const FEATURE_SETTINGS_KEYS = {
  THEME: 'theme',
  CANVAS: 'canvas',
  PERSONAL_INFO_VISIBILITY: 'personal_info_visibility',
};

export const PERSONAL_INFO_VISIBILITY_OPTIONS = {
  ONLY_ME: 'only_me',
  EVERYONE: 'everyone',
};

export const PERSONAL_INFO_VISIBILITY_SELECT_OPTIONS = Object.freeze(
  Object.values(PERSONAL_INFO_VISIBILITY_OPTIONS).map((value) => ({
    value,
    label:
      value === PERSONAL_INFO_VISIBILITY_OPTIONS.EVERYONE
        ? 'Everyone'
        : 'Only Me',
  }))
);

export const defaultNotificationSettings = {
  [NOTIFICATION_SETTINGS_KEYS.VOLUME]: 50,
  [NOTIFICATION_SETTINGS_KEYS.MUTED]: false,
};

export const defaultFeaturesSettings = {
  [FEATURE_SETTINGS_KEYS.THEME]: THEME_OPTIONS.DARK,
  [FEATURE_SETTINGS_KEYS.CANVAS]: true,
  [FEATURE_SETTINGS_KEYS.PERSONAL_INFO_VISIBILITY]:
    PERSONAL_INFO_VISIBILITY_OPTIONS.ONLY_ME,
};

export const SHOW_CANVAS = [THEME_OPTIONS.DARK];
